import {openLink} from 'client/common/utils/window';
import {sendGoal} from 'client/common/utils/metrika';
import {BannerGoal} from 'client/common/types/metrika';

import I18N from 'assets/i18n/brandlift-project';

const i18n = I18N.common.banner;

export const BAROMETR = {
    title: i18n.barometr.title,
    text: i18n.barometr.text,
    slug: i18n.barometr.slug,
    buttons: [
        {
            label: i18n.barometr.buttonText,
            onClick: ({queryParams}: {queryParams: Record<string, string>}) => {
                const searchParams = new URLSearchParams(queryParams);

                const link = new URL(`https://yandex.ru/poll/${i18n.barometr.slug}`);

                // дописываем в урл опроса гет-параметры про юзера
                searchParams.forEach((value, key) => {
                    link.searchParams.append(key, value);
                });

                sendGoal(BannerGoal.ActionClickTryBanner);
                openLink(link.toString(), true);
            }
        }
    ],
    buttonsLabel: i18n.barometr.buttonsLabel
};

/* export const OWN_BASE = {
    title: i18n.ownBase.title,
    text: i18n.ownBase.text,
    buttons: [
        {
            label: 'i18n.buttonText',
            onClick: () => {
                sendGoal(BannerGoal.ActionClickTryBanner);
                openLink(i18n.link);
            }
        }
    ]
}; */
